/**
 * 设置弹窗全局状态管理
 *
 * 功能:
 * - 统一管理所有设置相关的弹窗状态
 * - 提供打开/关闭弹窗的方法
 * - 避免在每个页面重复添加弹窗组件
 */

// 弹窗状态
const showReportDialog = ref(false)
const showRulesDialog = ref(false)
const showCustomBetDialog = ref(false)
const showBGMDialog = ref(false)
const showVideoLineDialog = ref(false)
const showSwitchSettingsDialog = ref(false)
const showCommandHelpDialog = ref(false)
const showChangePasswordDialog = ref(false)
const showContactServiceDialog = ref(false)

/**
 * 弹窗类型
 */
export type DialogType =
  | 'report'
  | 'rules'
  | 'customBet'
  | 'bgm'
  | 'videoLine'
  | 'settings'
  | 'command'
  | 'changePassword'
  | 'contact'

/**
 * 使用设置弹窗
 */
export function useSettingsDialogs() {
  /**
   * 打开指定弹窗
   */
  const openDialog = (type: DialogType) => {
    switch (type) {
      case 'report':
        showReportDialog.value = true
        break
      case 'rules':
        showRulesDialog.value = true
        break
      case 'customBet':
        showCustomBetDialog.value = true
        break
      case 'bgm':
        showBGMDialog.value = true
        break
      case 'videoLine':
        showVideoLineDialog.value = true
        break
      case 'settings':
        showSwitchSettingsDialog.value = true
        break
      case 'command':
        showCommandHelpDialog.value = true
        break
      case 'changePassword':
        showChangePasswordDialog.value = true
        break
      case 'contact':
        showContactServiceDialog.value = true
        break
    }
  }

  /**
   * 关闭指定弹窗
   */
  const closeDialog = (type: DialogType) => {
    switch (type) {
      case 'report':
        showReportDialog.value = false
        break
      case 'rules':
        showRulesDialog.value = false
        break
      case 'customBet':
        showCustomBetDialog.value = false
        break
      case 'bgm':
        showBGMDialog.value = false
        break
      case 'videoLine':
        showVideoLineDialog.value = false
        break
      case 'settings':
        showSwitchSettingsDialog.value = false
        break
      case 'command':
        showCommandHelpDialog.value = false
        break
      case 'changePassword':
        showChangePasswordDialog.value = false
        break
      case 'contact':
        showContactServiceDialog.value = false
        break
    }
  }

  /**
   * 关闭所有弹窗
   * 用于路由切换到登录页时清理弹窗状态
   */
  const closeAllDialogs = () => {
    showReportDialog.value = false
    showRulesDialog.value = false
    showCustomBetDialog.value = false
    showBGMDialog.value = false
    showVideoLineDialog.value = false
    showSwitchSettingsDialog.value = false
    showCommandHelpDialog.value = false
    showChangePasswordDialog.value = false
    showContactServiceDialog.value = false
  }

  return {
    // 状态
    showReportDialog,
    showRulesDialog,
    showCustomBetDialog,
    showBGMDialog,
    showVideoLineDialog,
    showSwitchSettingsDialog,
    showCommandHelpDialog,
    showChangePasswordDialog,
    showContactServiceDialog,
    // 方法
    openDialog,
    closeDialog,
    closeAllDialogs,
  }
}
